import { Spinner } from 'react-bootstrap';

import 'pdfjs-dist/build/pdf.mjs';
import 'pdfjs-dist/web/pdf_viewer.css';

interface IPdfViewerProps {
  pdfUrl: string;
  isPdfViewerEnabled: () => boolean;
}

const PdfViewer = ({ pdfUrl, isPdfViewerEnabled }: IPdfViewerProps) => {
  return (
    <div
      className="d-flex"
      style={{
        overflow: 'hidden',
        paddingLeft: '15px',
        height: '100%',
        width: '50%',
      }}
    >
      {pdfUrl && isPdfViewerEnabled() ? (
        <iframe
          id="report-viewer-frame"
          src={`${pdfUrl}#zoom=FitW&toolbar=0&navpanes=0&scrollbar=0`}
          title="Report"
          style={{ width: '100%', height: '100%' }}
        />
      ) : (
        <div className="p-4 w-100 text-center">
          <Spinner className="mx-5 my-5" variant="primary" />
        </div>
      )}
    </div>
  );
};

export default PdfViewer;
